import { useQuery } from "@tanstack/react-query";

import { useAuthenticatedRequest } from "./useRequests";
import { PagedResult } from "models/common";
import { Listing } from "models/cards";

const useTopActiveListings = (accountId: string) => {
    const getData = useAuthenticatedRequest<PagedResult<Listing>>({
        url: `/cards/${accountId}?page=1&sortKey=SalePriceInCents&sortAsc=false&filterBy%5BStatus%5D=Active`,
        method: "GET",
    });

    return useQuery(["topActiveListings", accountId], getData);
};

export default useTopActiveListings;
